import { DeleteSquareIcon } from '@/assets/icons';
import { memo } from 'react';

import Button, { IButton } from '../button';
import HyperLink, { HyperLinkProps } from '../hyper-link';

type SelectButtonProps = {
	hyperLinkProps?: Omit<HyperLinkProps, 'children'>;
	text?: string;
	buttonProps?: Omit<IButton, 'children'>;
	buttonText?: string;
	onDelete?: () => void;
	action?: React.ReactNode;
	disabled?: boolean;
	callback?: () => void;
};

const SelectButton = ({
	hyperLinkProps,
	text,
	buttonProps,
	buttonText = '조회',
	onDelete,
	action,
	disabled,
	callback,
}: SelectButtonProps) => {
	return (
		<div className="flex items-center gap-2">
			{text && (
				<div className="flex items-center gap-1">
					<HyperLink {...hyperLinkProps} callback={callback}>
						{text}
					</HyperLink>
					{!disabled && (
						<DeleteSquareIcon className="cursor-pointer" onClick={onDelete} />
					)}
				</div>
			)}

			{!disabled &&
				(action ? (
					action
				) : (
					<Button secondary {...buttonProps}>
						{buttonText}
					</Button>
				))}
		</div>
	);
};

export default memo(SelectButton);
